import { VAlert } from 'vuetify/lib/components/VAlert';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "ma-10" },
    [
      _c(
        VAlert,
        {
          attrs: {
            dismissible: "",
            icon: false,
            color: _vm.matchConditions(_vm.info.approval_status, "color"),
          },
          scopedSlots: _vm._u([
            {
              key: "close",
              fn: function () {
                return [
                  _c(
                    "div",
                    { staticClass: "close-container" },
                    [
                      _c(
                        VIcon,
                        {
                          staticStyle: { color: "white" },
                          on: {
                            click: function ($event) {
                              _vm.isOpen = false
                            },
                          },
                        },
                        [_vm._v("\n          mdi-close-circle\n        ")]
                      ),
                    ],
                    1
                  ),
                ]
              },
              proxy: true,
            },
          ]),
          model: {
            value: _vm.isOpen,
            callback: function ($$v) {
              _vm.isOpen = $$v
            },
            expression: "isOpen",
          },
        },
        [
          _c(
            "div",
            { staticClass: "header-container" },
            [
              _c(
                VCol,
                { attrs: { cols: "auto" } },
                [
                  _c(
                    VIcon,
                    { staticStyle: { color: "white" }, attrs: { size: 80 } },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(
                            _vm.matchConditions(
                              _vm.info.approval_status,
                              "icon"
                            )
                          ) +
                          "\n        "
                      ),
                    ]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                VCol,
                {
                  staticClass: "title-container",
                  staticStyle: { color: "white" },
                },
                [
                  _c(
                    "div",
                    { staticClass: "title-notification" },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(
                            _vm.matchConditions(
                              _vm.info.approval_status,
                              "title"
                            )
                          ) +
                          "\n          "
                      ),
                      _vm.info.approval_status === "REJECTED"
                        ? _c(VChip, [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.info.categoryName) +
                                "\n          "
                            ),
                          ])
                        : _vm._e(),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "time-notification" }, [
                    _vm._v(
                      "\n          " +
                        _vm._s(
                          _vm._f("displayDate")(
                            _vm.info.updated_at,
                            _vm.info.approval_status,
                            _vm.info.adminName
                          )
                        ) +
                        "\n        "
                    ),
                  ]),
                ]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _vm.info.approval_verdict !== "" ||
          _vm.info.approval_status !== "APPROVED"
            ? _c(
                "div",
                { staticStyle: { color: "white" } },
                [
                  _vm.info.approval_status !== "PENDING" &&
                  _vm.info.approval_verdict !== ""
                    ? _c(
                        VRow,
                        { staticClass: "content-notification" },
                        [
                          _c(VCol, { staticClass: "mx-4" }, [
                            _c("h3", [
                              _vm._v(
                                "\n            " +
                                  _vm._s(
                                    _vm.$t("m2301.notification.adminComment") +
                                      " :"
                                  ) +
                                  "\n          "
                              ),
                            ]),
                          ]),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    VRow,
                    { staticClass: "content-notification" },
                    [
                      _c(VCol, { staticClass: "mb-4 mx-4 pt-0" }, [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm.info.approval_verdict !== null ||
                                _vm.info.approval_status !== "PENDING"
                                ? _vm.info.approval_verdict
                                : _vm.$t("m2301.notification.pendingMessage")
                            ) +
                            "\n        "
                        ),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }